import React, { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import ShareIconWhite from '../../../../../assests/header/icons/share-icon-white.png'
import ShareIconDark from '../../../../../assests/header/icons/share-icon-dark.png'
import useClickOutside from "../../../../../hooks/useClickOutside"
import Share from "../../HeaderDashboard/Share"
import IconHeaderBackground from "../IconHeaderBackground"
import classes from '../Icons.module.css'
import { onKeyDown } from "../../../../../service"


const ShareBtn = () => {

    const [showShare, setShowShare] = useState(false)
    const texts = useSelector(state => state.translate.texts);
    const popupRef = useRef(null);

    useClickOutside(popupRef, () => {
        setShowShare(false);
    });

    function open(e) {
        setShowShare(prevShowShare => !prevShowShare)
    }

    return (
        <div ref={popupRef} className={` ${!showShare ? classes.Icon : classes.OpenIconImg}`}>
            <img src={` ${showShare ? ShareIconDark : ShareIconWhite}`} alt='ShareIcon' className={classes.IconImg} onClick={(e) => open(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => open(e))} />
            {showShare && <IconHeaderBackground title={texts.share} close={() => setShowShare(false)}> <Share /> </IconHeaderBackground>}
        </div>
    )
}

export default ShareBtn